import crypto from 'crypto'

// 使用公钥加密数据
function publicEncrypt(data, publicKey, encoding) {
  console.log('data, publicKey, encoding', data, publicKey, encoding)
  const msg = JSON.stringify(data);
  const encryptBuffer = crypto.publicEncrypt({
    key: publicKey,
    padding: crypto.constants.RSA_PKCS1_PADDING // 填充方式，需与解密一致
  }, Buffer.from(msg, 'utf8'));
  if (encoding) {
    return encryptBuffer.toString(encoding);
  } else {
    return encryptBuffer;
  }
}

// 使用公钥解密数据
function publicDecrypt(publicKey, encryptBuffer) {
  const msgBuffer = crypto.publicDecrypt({
    key: publicKey,
    padding: crypto.constants.RSA_PKCS1_PADDING
  }, encryptBuffer);

  return JSON.parse(msgBuffer.toString('utf8'));
}

export default {
  publicEncrypt,
  publicDecrypt
}
